export enum VBKType {
  EPUB = "epub",
  PBK = "pbk",
}

interface Feature {
  name: string;
  status: number;
  partner_id: string;
  options: {};
}

export interface BookInfo {
  title: string;
  author: string;
  vbkType: VBKType;
  isFixedLayout: boolean;
  dpsAvailable: false;
  hasPageBreaks: boolean;
  vbid: string;
  coverWidths: number[];
  coverURL: string;
  isbn: string;
  features: Feature[];
  hasAncillaries: boolean;
  copyLimit: number | null | undefined;
  ssoOnly: boolean;
}
